import "../ styles/message.css";

export const Message = ({ user, message }) => {
  return (
    <div className="nameMessage">
      <div>
        <h3 className="message">{message}</h3>
      </div>
      <div>
        <p className="user">{user}</p>
      </div>
    </div>
  );
};
